import { render, staticRenderFns } from "./addcommercial_dkxq_edit.vue?vue&type=template&id=2513800d&scoped=true&"
import script from "./addcommercial_dkxq_edit.vue?vue&type=script&lang=js&"
export * from "./addcommercial_dkxq_edit.vue?vue&type=script&lang=js&"
import style0 from "./addcommercial_dkxq_edit.vue?vue&type=style&index=0&id=2513800d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2513800d",
  null
  
)

export default component.exports